/* eslint-disable @typescript-eslint/no-this-alias */
import React from 'react';
import LocationsCalendar from '../myspace/providers/locations_calendar/LocationsCalendar.jsx';

export default class ConfigureFormCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.status_requests_hotels = typeof fc_status_requests_hotels == 'undefined' ? 'rh_en_attente' : fc_status_requests_hotels;
        this.devisInputProductLabel = $('#products_product_label_' + this.props.index);

        this.devisInputHourStart = $('#products_locations_hour_start_' + this.props.index);
        this.devisInputHourEnd = $('#products_locations_hour_end_' + this.props.index);

        this.showCalendarIcon = $('.show-calendar');
        this.calendarContainerId = 'form-modal-calendar-container';
        this.calendar = null;
        this.product_detail_id_selected = 0;
        this.currentLabel = this.devisInputProductLabel.val();
        this.currentDates = [];

        this.currentEvents = {};
        this.currentProductEvents = [];
        
        this.dateStartMin = null;

        this.dataInputSelector = '[name^="products["][name$="][__KEY__]"]';
        

        this.state = {
            isLoaded: false,
            eventsDateStart: null,
            devisEvents: null,
            updateIndex : 0
        }

        this.first_load = true;
        this.should_refresh_products = false;
        this.should_refresh_calendar = false;
    }

    shouldComponentUpdate(nextProps, nextState) {

        let propsChanged = false;
        if (this.props.type == 'product') {
            propsChanged = this.compareProductInfos(nextProps, this.props);
        } else if (this.props.type == 'package') {
            let propsPackageChanged = false;
            for (const [key, product] of Object.entries(this.props.products_packages)) {
                propsPackageChanged ||= this.compareProductInfos(nextProps.products_packages[key], product);
            }
            propsChanged = propsPackageChanged;
        }

        this.should_refresh_products = propsChanged;
        this.should_refresh_calendar = (nextState.updateIndex !== this.state.updateIndex )

        return nextProps.parentLoaded && (propsChanged || this.first_load || this.should_refresh_calendar);
    }

    componentDidMount() {
        this.createEvents();
    }

    componentDidUpdate() {
        this.first_load = false;
        if(this.should_refresh_products) {
            this.updateEvents(); 
        }
    }

    compareProductInfos(nextProd, currentProd) {
        return (
            nextProd.hour_start != currentProd.hour_start ||
            nextProd.hour_end != currentProd.hour_end ||
            nextProd.pax != currentProd.pax ||
            nextProd.meeting_rooms_type_slug != currentProd.meeting_rooms_type_slug ||
            nextProd.locations_id != currentProd.locations_id ||
            nextProd.product_label != currentProd.product_label || 
            nextProd.date_shift != currentProd.date_shift
        );
    }

    // On charge les événements du devis
    createEvents() {

        let _this = this;
        let devisEvents = {};
        $.each($('.products_locations_locations_id'), function () {
            let index = $(this).data('index');
            let root_index = _this.rootIndex(index);
            
            let date_shift = parseInt($(`.products_details_date_shift[data-index="${index}"]`).val(), 10) || 0;
            let time_start = $(`.products_locations_hour_start[data-index="${index}"]`).val();
            let time_end = $(`.products_locations_hour_end[data-index="${index}"]`).val();
            let pax = $(`.products_locations_pax[data-index="${index}"]`).val();
            let meeting_rooms_type_slug = $(`.products_locations_meeting_rooms_type_slug[data-index="${index}"]`).val();
            let products_id = $(this).data('products_id');
            let product_type = $('.product_row[data-index="'+root_index+'"]').data('product_type');
            
            let all_locations_id = $(this).val();
            let tab_locations_id = all_locations_id.split(',');

            let current_product = root_index == parseInt(_this.props.index) ? 1 : 0;

            if(product_type != 'rooms_types') {
                $.each($(`.products_details_date[data-index="${root_index}"]`), function () {
                    let date = $(this).data('date');
                    let shiftedDate = date;
                    if ( date_shift != 0 ) {
                        shiftedDate = new Date(date);
                        shiftedDate.setDate(shiftedDate.getDate()+date_shift);
                        shiftedDate = shiftedDate.yyyymmdd();
                    }
                    let key = `${index}_${date}`;
                    let qty = parseInt($(`.gc_quantity[data-index="${root_index}"][data-date="${date}"]`).val(), 10);
                    if (qty > 0 && time_start != '') {
                        let evt = {
                            locations_ids : tab_locations_id,
                            time_start: time_start,
                            time_end: time_end,
                            date_shift: date_shift,
                            products_id: products_id,
                            product_label: $(`#products_product_label_${index}`).val(),
                            date: shiftedDate,
                            index: index,
                            qty: qty,
                            pax: pax,
                            meeting_rooms_type_slug: meeting_rooms_type_slug,
                            current_product: current_product
                        };
                        devisEvents[key]  = evt;
                    }
    
                });
            }
        });
        this.setState({
            devisEvents: devisEvents
        });
        
    } // end of 'createEvents()'

    updateEvents() {
        if (this.props.type == 'package') {
            this.updatePackageEvents();
        } else if (this.props.type == 'product') {
            this.updateProductEvents();
        }
    }

    updateProductEvents() {
        let _this = this;
        let root_index = this.rootIndex(this.props.index);
        var tab_locations_ids = this.props.locations_id.split(',');

        let date_shift = parseInt($(`.products_locations_date_shift[data-index="${root_index}"]`).val(), 10) || 0;
        let products_id = $(this).data('products_id');
        let devisEvents = {...this.state.devisEvents };

        $.each($(`.products_details_date[data-index="${root_index}"]`), function () {
            let date = $(this).data('date');
            let key = `${_this.props.index}_${date}`;
            let event = devisEvents[key] ?? null;
            let qty = parseInt($(`.gc_quantity[data-index="${root_index}"][data-date="${date}"]`).val(), 10);
            if (qty > 0 && _this.props.hour_start != '') {
                if(event) {
                    event['locations_ids'] = tab_locations_ids;
                    event['time_start'] = _this.props.hour_start;
                    event['time_end'] = _this.props.hour_end;
                    event['pax'] = _this.props.pax;
                    event['meeting_rooms_type_slug'] = _this.props.meeting_rooms_type_slug;
                    event['current_product'] = 1;
                    devisEvents[key] = event;
                } else {
                    let event = {
                        locations_ids : tab_locations_ids,
                        time_start: _this.props.hour_start,
                        time_end: _this.props.hour_end,
                        date_shift: date_shift,
                        products_id: products_id,
                        product_label: $(`#products_product_label_${root_index}`).val(),
                        date: date,
                        qty: qty,
                        pax: _this.props.pax,
                        meeting_rooms_type_slug: _this.props.meeting_rooms_type_slug,
                        current_product: 1
                    };
                    devisEvents[key] = event;
                }
                
            } else {
                if(event) {
                    delete devisEvents[key];
                }
            }
            
            
        });

        this.setState({
            devisEvents: devisEvents,
            updateIndex: this.state.updateIndex + 1
        });
    }

    updatePackageEvents() {
        let _this = this;
        let root_index = this.rootIndex(this.props.index);
        let devisEvents = {...this.state.devisEvents };
        for (const [key, product] of Object.entries(this.props.products_packages)) {
            var tab_locations_ids = product.locations_id.split(',');
            $.each($(`.products_details_date[data-index="${root_index}"]`), function () {
                let date = $(this).data('date');
                let shiftedDate = date;
                if ( product.date_shift != '' ) {
                    shiftedDate = new Date(date);
                    shiftedDate.setDate(shiftedDate.getDate()+parseInt(product.date_shift));
                    shiftedDate = shiftedDate.yyyymmdd();
                }
                let package_key = `${key}_${date}`;
                let event = devisEvents[package_key] ?? null;
                let qty = parseInt($(`.gc_quantity[data-index="${root_index}"][data-date="${date}"]`).val(), 10);

                if (qty > 0 && _this.props.hour_start != '') {
                    if(event) {
                        event['locations_ids'] = tab_locations_ids;
                        event['time_start'] = product.hour_start;
                        event['time_end'] = product.hour_end;
                        event['pax'] = product.pax;
                        event['date_shift'] = product.date_shift;
                        event['meeting_rooms_type_slug'] = product.meeting_rooms_type_slug;
                        event['product_label'] = product.product_label;
                        event['current_product'] = 1;
                        event['date'] = shiftedDate;
                        devisEvents[package_key] = event;
                    } else {
                        let event = {
                            locations_ids : tab_locations_ids,
                            time_start: product.hour_start,
                            time_end: product.hour_end,
                            date_shift: product.date_shift,
                            products_id: product.id,
                            product_label: product.product_label,
                            date: shiftedDate,
                            qty: qty,
                            pax: product.pax,
                            meeting_rooms_type_slug: product.meeting_rooms_type_slug,
                            current_product: 1
                        };
                        devisEvents[package_key] = event;
                    }
                } else {
                    if(event) {
                        delete devisEvents[package_key];
                    }
                }

            });

        }

        this.setState({
            devisEvents: devisEvents,
            updateIndex: this.state.updateIndex + 1
        });
    }

    rootIndex(index) {

        let root_index = index;

        if (/^(new_[a-z0-9]+_[0-9]+|[0-9]+_[0-9]+)$/.test(index)) {
            root_index = index.toString().split('_').slice(0, -1).join('_');
        } // endif

        return root_index;

    } // end of 'rootIndex()'

    render() {
        return (
            <LocationsCalendar
                id="configure-form-calendar"
                hotelsId={this.props.hotels_id}
                excludeRequestsHotelsId={this.props.requests_hotels_id}
                requestsHotelsId={this.props.requests_hotels_id}
                showPopoverLinks={false}
                variablesEvents={this.state.devisEvents}
                dateStart={this.props.date_start}
                resizeHeight={40}
                calendarOnly={true}
                baseCurrentUrl={this.props.base_current_url}
            />
        )
    }
}